import cloneDeep from 'lodash/cloneDeep';
import sortBy from 'lodash/sortBy';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ngHelper } from '@cakeiteasy/web-utils';

import { WEEK_DAYS_SORTING, GROUPS_WEEK_DAYS_SORTING } from '../../delivery.constant';
import { IOverwritingDelivery } from '../../../cart';

@Component({
  standalone: false,
  selector: 'delivery-days-info',
  templateUrl: 'delivery-days-info.component.html',
  styleUrls: ['./delivery-days-info.component.scss']
})
export class DeliveryDaysInfoComponent implements OnChanges {
  @Input() overwritingDelivery: IOverwritingDelivery;
  @Input() currencySymbol: string;
  @Input() deliveryPrices: any[];

  public dayPrices: any[];

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'deliveryPrices', (deliveryPrices) => {
      this._prepareDayPrices(deliveryPrices);
    });
  }

  private _prepareDayPrices(deliveryPrices) {
    this.dayPrices = cloneDeep(deliveryPrices);

    this.dayPrices.forEach((priceInfo) => {
      // adding main range to unify the iteration over prices
      priceInfo.customPrices.unshift({
        price: priceInfo.price,
        start: priceInfo.timeRange.start,
        end: priceInfo.timeRange.end
      });

      priceInfo.ranges = priceInfo.customPrices;
    });

    const WEEK_DAYS = deliveryPrices.length === 7 ? WEEK_DAYS_SORTING
      : GROUPS_WEEK_DAYS_SORTING;

    this.dayPrices = sortBy(this.dayPrices, [(day) => WEEK_DAYS[day.type]]);
  }
}
